import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsTable from "../ui/LmsTable";

const BorrowerStatementCurrentInterestOwingTable = () => {
  const actionsButtons = ["export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="report/borrower-statement-current-interest-owing"
    calculatedColumns={["transactionAmount"]}
    skipClick
  />;
};

const LmsReportsBorrowerStatementCurrentInterestOwing = ({ params = {}, history }) => {
  const { isActionAllowed } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return ( <BorrowerStatementCurrentInterestOwingTable /> );
};

export default LmsReportsBorrowerStatementCurrentInterestOwing;